<template>
  <div class="home-wrapper container mt-5 text-center">
    <div class="row justify-content-center">
      <div class="col-5 text-center">
        <img class="img-fluid" alt="Domeo - assemblées" src="../assets/images/logo.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
